import axiosInstance from './AxiosInstance';

export const getLatestTransactions = async () => {
  const response = await axiosInstance.get('/graph/latest-transactions');
  return response.data;
};
